import React, { FC, Suspense } from 'react'
import { styled } from '@creditas/stylitas'

import { Upsell } from './Upsell'
import { InspectionAppraisalAndIdentityProof } from './InspectionAppraisalAndIdentityProof'
import { NextContact } from './NextContact'
import { ResidenceProofAndIncomeProof } from './ResidenceProofAndIncomeProof'
import { InspectionAppraisalAndIdentityProofContentFetching } from './InspectionAppraisalAndIdentityProofContentFetching'
import { ResidenceProofAndIncomeProofContentFetching } from './ResidenceProofAndIncomeProofContentFetching'

const Container = styled.div`
  width: 100%;
  color: #556666;
  display: flex;
  font-size: 14px;
  line-height: 20px;
  padding: 8px;

  b {
    font-weight: 700;
  }
`

const LeftContainer = styled.div`
  width: 40%;

  p:first-of-type {
    margin-bottom: 8px;
  }

  strong {
    color: #11bb77;
  }

  svg {
    position: relative;
    top: 4px;
    left: 4px;
  }
`

const RightContainer = styled.div`
  width: 60%;

  p:first-of-type {
    margin-bottom: 8px;
  }

  svg {
    position: relative;
    top: 4px;
    left: 4px;
  }
`

const AdditionalInformation: FC<{
  applicationId: string
  nextContact: Date | null
}> = ({ applicationId, nextContact }) => {
  return (
    <Container>
      <LeftContainer>
        <Upsell applicationId={applicationId} />
        <Suspense
          fallback={<InspectionAppraisalAndIdentityProofContentFetching />}
        >
          <InspectionAppraisalAndIdentityProof applicationId={applicationId} />
        </Suspense>
      </LeftContainer>
      <RightContainer>
        <NextContact nextContact={nextContact} />
        <Suspense fallback={<ResidenceProofAndIncomeProofContentFetching />}>
          <ResidenceProofAndIncomeProof applicationId={applicationId} />
        </Suspense>
      </RightContainer>
    </Container>
  )
}

export default AdditionalInformation
